import { ApplicationGoogleDoc } from "@prisma/client";
import axios from "axios";

interface UploadGoogleDocParams {
  googleDriveDir: string | null;
  applicationId: string | null;
  blob: Blob;
  type: string | null;
  fileName: string | null;
  fileExtension: string | null;
  meta?: Record<string, any>;
}

export const uploadGoogleDoc = async ({
  googleDriveDir,
  applicationId,
  blob,
  type,
  fileName,
  fileExtension,
  meta,
}: UploadGoogleDocParams): Promise<ApplicationGoogleDoc | null> => {
  if (
    !blob ||
    !fileName ||
    !googleDriveDir ||
    !applicationId ||
    !type ||
    !fileExtension
  ) {
    console.warn("Error while generating google doc: bad params");
    return null;
  }

  const data = new FormData();
  data.append("googleDriveDir", googleDriveDir);
  data.append("fileName", fileName);
  data.append("fileExtension", fileExtension);
  data.append("type", type);
  data.append("blob", blob);

  if (meta) {
    data.append("meta", JSON.stringify(meta));
  }

  return await axios
    .post(
      `${process.env.NEXT_PUBLIC_API_URL}/application/${applicationId}/google-doc`,
      data,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    )
    .then((res) => res.data)
    .catch((err) => console.warn("Error while generating google doc", err));
};

export const deleteGoogleDoc = async (
  applicationId: string,
  id: string,
  googleDriveId: string
) => {
  return await axios
    .delete(
      `${process.env.NEXT_PUBLIC_API_URL}/application/${applicationId}/google-doc/`,
      {
        params: {
          id,
          googleDriveId,
        },
      }
    )
    .then((res) => res.data);
};

export const fetchApplicationGoogleDocList = async (
  applicationId: string,
  refereeId?: string
) => {
  return await axios
    .get(
      `${process.env.NEXT_PUBLIC_API_URL}/application/${applicationId}/google-doc`,
      {
        params: {
          refereeId,
        },
      }
    )
    .then((res) => res.data)
    .catch((err) => console.warn("Error while getting google doc list", err));
};
